// extracted by mini-css-extract-plugin
export default {"button":"ProjectBtn_button__3o+KR","bgLight":"ProjectBtn_bgLight__qYxVr","bgDark":"ProjectBtn_bgDark__T4Th5"};